<template>
  <div>
      <div class="center">
        Llamada telefónica
      </div>

      <div style="margin: 10px 10px 0px 10px">
        <div>
            <v-select
              @change="selectClicked"
              placeholder="Seleccione una opción"
              :items="items"
              label="Contactos"
              v-model="item"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{MetodoSeleccion}} {{ item }}</span>
                </v-chip>
              </template>
              <template v-if="item" slot="append-outer">
                <v-btn fab icon x-small @click="llamadaTelefonica"><v-icon>mdi-phone-in-talk</v-icon></v-btn>
                <v-btn fab icon x-small @click="mensajeTexto"><v-icon>mdi-message-text</v-icon></v-btn>
              </template>
            </v-select>
        </div>
        <v-textarea hide-details height="80px" outlined dense placeholder=" " >
          <template v-slot:label>
            <div>
              Comentarios <small> (opcional)</small>
            </div>
          </template>
        </v-textarea>
      </div>
  </div>
</template>

<script>
import EventBus from '@/components/event-bus'

export default {
    name: 'PlanReaccionLlamadaContactos',
    props:{
        title: String
    },
    data: () => ({
         items: ["55-55-33-88", "55-59-89-89"],
         item: null,
         MetodoSeleccion: null
    }),
    methods:{
      llamadaTelefonica(){
        this.MetodoSeleccion = "Llamada a "
        window.location.href='tel:+91123456789'
      },
      mensajeTexto(){
        this.MetodoSeleccion = "Mensaje a "
        window.location.href='sms:+91123456789'
      },
      selectClicked(){
          //console.log('v-select', this.item)
      }
    }
}
</script>

<style scoped>
.center {
  text-align: center;
  margin: auto;
}
</style>
